export default __webpack_public_path__ + "static/media/300.ef26dc4f.png";